import { Component } from '@angular/core'
import { Bootstrap_Modal_Service, Bootstrap_Modal_Service_Config } from '@services/bootstrap-modal.service'

@Component({
  selector: 'app-bootstrap-modal',
  templateUrl: './bootstrap-modal.component.html'
})
export class BootstrapModalComponent {

  config: Bootstrap_Modal_Service_Config | null = null

  constructor(
    private modalService: Bootstrap_Modal_Service) {

    this.modalService.modal$.subscribe(config => {
      this.config = config;
    })

  }

  close() {
    this.modalService.close()
  }

}
